if (productMetafields && productMetafields.camp_type_id) {
    // Modal
  
    var MODAL_OPEN_BUTTON_SELECTOR = ".camp-modal-open-button";
    var MODAL_SELECTOR = ".camp-modal";
    var MODAL_OVERLAY_SELECTOR = ".camp-modal-overlay";
    var MODAL_CONTAINER_SELECTOR = ".camp-modal-container";
    var MODAL_CONTENT_SELECTOR = ".camp-modal-content";
    var MODAL_ACTIVE_CLASS = "camp-modal--active";
    var MODAL_OVERLAY_ACTIVE_CLASS = "camp-modal-overlay--active";
    var MODAL_CONTENT_ACTIVE_CLASS = "camp-modal-content--active";
    var MODAL_CLOSE_BUTTON_SELECTOR = ".camp-modal-close-button";
    var MODAL_SUCCESS_BUTTON = ".camp-modal-success-button";
  
    var KEY_CODES = {
      Tab: 9,
      Escape: 27,
    };
  
    var campOrderNumber = "";
  
    var modal = document.querySelector(MODAL_SELECTOR);
    var user = false;
    var idToken;
    let focusedElementBeforeOpen;
    let focusableElements;
  
    function focusFirstFocusableElement() {
      focusableElements[0].focus();
    }
  
    function focusLastFocusableElement() {
      focusableElements[focusableElements.length - 1].focus();
    }
  
    function setFocusableElements(parentElement) {
      var elementsWithFocus = parentElement.querySelectorAll(
        'a[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), [tabindex="0"]'
      );
      var modalClosebutton = document.querySelectorAll(
        MODAL_CLOSE_BUTTON_SELECTOR
      );
  
      focusableElements = Array.prototype.slice
        .call(elementsWithFocus)
        .concat(Array.prototype.slice.call(modalClosebutton));
    }
  
    function openModal(event) {
      if (event) event.preventDefault();
      initSelectionForm();
      setFocusableElements(document.querySelector(FORM_SELECTOR));
  
      document.body.style.overflow = "hidden";
  
      focusedElementBeforeOpen = document.activeElement;
  
      modal.classList.add(MODAL_ACTIVE_CLASS);
  
      var modalOverlay = document.querySelector(MODAL_OVERLAY_SELECTOR);
      var modalContainer = document.querySelector(MODAL_CONTAINER_SELECTOR);
      var modalContent = document.querySelector(MODAL_CONTENT_SELECTOR);
      var modalCloseButton = document.querySelector(MODAL_CLOSE_BUTTON_SELECTOR);
      var successButton = document.querySelector(MODAL_SUCCESS_BUTTON);
  
      setTimeout(() => {
        modalOverlay.classList.add(MODAL_OVERLAY_ACTIVE_CLASS);
        modalContent.classList.add(MODAL_CONTENT_ACTIVE_CLASS);
      }, 10);
  
      focusFirstFocusableElement();
  
      modal.addEventListener("keydown", handleKeyDown);
      modalContainer.addEventListener("click", handleContainerClick);
      modalCloseButton.addEventListener("click", closeModal);
      successButton.addEventListener("click", closeModal);
    }
  
    function closeModal() {
      if (focusedElementBeforeOpen) {
        focusedElementBeforeOpen.focus();
      }
  
      document.body.style.removeProperty("overflow");
  
      focusedElementBeforeOpen = null;
  
      var modalOverlay = document.querySelector(MODAL_OVERLAY_SELECTOR);
      var modalContainer = document.querySelector(MODAL_CONTAINER_SELECTOR);
      var modalContent = document.querySelector(MODAL_CONTENT_SELECTOR);
      var modalCloseButton = document.querySelector(MODAL_CLOSE_BUTTON_SELECTOR);
  
      modalOverlay.classList.remove(MODAL_OVERLAY_ACTIVE_CLASS);
      modalContent.classList.remove(MODAL_CONTENT_ACTIVE_CLASS);
  
      setTimeout(() => {
        modal.classList.remove(MODAL_ACTIVE_CLASS);
  
        resetSelectionForm();
        resetSendCodeForm();
        resetValidateCodeForm();
        toggleShowSelectionForm(true);
        toggleShowCodeForm(false);
        toggleShowValidateForm(false);
      }, 300);
  
      modal.removeEventListener("keydown", handleKeyDown);
      modalContainer.removeEventListener("click", handleContainerClick);
      modalCloseButton.removeEventListener("click", closeModal);
    }
    function handleBackwardTab(event) {
      if (document.activeElement === focusableElements[0]) {
        event.preventDefault();
        focusLastFocusableElement();
      }
    }
  
    function handleForwardTab(event) {
      if (
        document.activeElement === focusableElements[focusableElements.length - 1]
      ) {
        event.preventDefault();
        focusFirstFocusableElement();
      }
    }
  
    function handleTab(event) {
      if (focusableElements.length === 1) {
        event.preventDefault();
  
        return;
      }
  
      if (event.shiftKey) {
        handleBackwardTab(event);
      } else {
        handleForwardTab(event);
      }
    }
  
    function handleKeyDown(event) {
      switch (event.keyCode) {
        case KEY_CODES.Tab:
          handleTab(event);
          break;
        case KEY_CODES.Escape:
          closeModal();
          break;
        default:
          break;
      }
    }
  
    function handleContainerClick(event) {
      if (
        event.target.classList.contains(MODAL_CONTAINER_SELECTOR.replace(".", ""))
      ) {
        closeModal();
      }
    }
  
    function initModal() {
      var modalOpenButton = document.querySelector(MODAL_OPEN_BUTTON_SELECTOR);
      if (modalOpenButton) {
        modalOpenButton.addEventListener("click", openModal);
      }
    }
  
    initModal();
  
    // Selection form
  
    var campoptions = [];
  
    var FORM_SELECTOR = "#campModalSelectionForm";
    var FORM_CONTAINER_SELECTOR = "#campModalSelection";
    var SUCCESS_SELECTOR = "#campModalSuccess";
    var START_SELECT_SELECTOR = ".camp-modal-start-select";
    var DISCOUNT_CODE_BUTTON_SELECTOR = ".camp-modal-discount-code-button";
    var DISCOUNT_CODE_INPUT_SELECTOR = ".camp-modal-discount-code-input";
    var DISCOUNT_CODE_INPUT_WRAPPER_SELECTOR =
      ".camp-modal-discount-code-input-wrapper";
    var DISCOUNT_CODE_INPUT_WRAPPER_ACTIVE_CLASS =
      "camp-modal-discount-code-input-wrapper--active";
    var REDIRECT_URL = "https://medlem.mkuniverset.dk/";
  
    var form = document.querySelector(FORM_SELECTOR);
    var formcontainer = document.querySelector(FORM_CONTAINER_SELECTOR);
    var success = document.querySelector(SUCCESS_SELECTOR);
    var startSelectInput = document.querySelector(START_SELECT_SELECTOR);
    var discountCodeInput = document.querySelector(DISCOUNT_CODE_INPUT_SELECTOR);
    var discountCodeInputWrapper = document.querySelector(
      DISCOUNT_CODE_INPUT_WRAPPER_SELECTOR
    );
    var discountCodeButton = document.querySelector(
      DISCOUNT_CODE_BUTTON_SELECTOR
    );
  
    var discountCodeValidateButton = document.querySelector(
      ".camp-modal-discount-code-button-validate"
    );
  
    
  
    // TODO: Replace with real logged in check
    var isLoggedIn = false;
  
    function toggleShowSelectionForm(show) {
      if (show) {
        form.style.display = "block";
      } else {
        form.style.display = "none";
      }
    }
  
    function insertSelectionStartOptions() {
      campoptions.forEach(function (option) {
        var optionElement = document.createElement("option");
  
        optionElement.value = option.value;
        optionElement.innerText = option.name;
  
        startSelectInput.appendChild(optionElement);
      });
    }
  
    function redirectToPayment() {
      var paymentButton = document.querySelector(".camp-modal-continue-button");
      paymentButton.disabled = true;
      paymentButton.innerText = "Forbereder betaling...";
      validateCodeButton.innerText = "Forbereder betaling...";
      var currentUrlWithoutQueryString =
        window.location.origin + window.location.pathname;
  
      firebase
        .functions()
        .httpsCallable("createCampOrder")({
          campId: startSelectInput.value,
          appId: "web",
          paymentType: "dankort, mastercard, mobilepay, visa",
          redirectLink: currentUrlWithoutQueryString,
          coupon: discountCodeInput.value,
        })
        .then((data) => {
          location.href = data.data.paymentLink;
        });
    }
  
    function onSelectionFormSubmit(event) {
      event.preventDefault();
  
      if (isLoggedIn) {
        redirectToPayment();
      } else {
        toggleShowSelectionForm(false);
        toggleShowCodeForm(true);
      }
    }
  
    function toggleDiscountCodeInput(show) {
      if (show) {
        discountCodeButton.style.display = "none";
        discountCodeInputWrapper.classList.add(
          DISCOUNT_CODE_INPUT_WRAPPER_ACTIVE_CLASS
        );
        discountCodeInput.setAttribute("tabindex", "0");
        setFocusableElements(document.querySelector(FORM_SELECTOR));
        discountCodeInput.focus();
      } else {
        discountCodeButton.style.display = "inline-block";
        discountCodeInputWrapper.classList.remove(
          DISCOUNT_CODE_INPUT_WRAPPER_ACTIVE_CLASS
        );
        discountCodeInput.setAttribute("tabindex", "-1");
      }
    }
  
    function resetSelectionForm() {
      if (form) {
        form.style.display = "block";
        startSelectInput.selectedIndex = 0;
        discountCodeInput.value = "";
  
        toggleDiscountCodeInput(false);
      }
    }
  
    function validateCouponCode() {
      discountCodeValidateButton.innerText = "Validerer..."
      isCampCouponCodeValid({ couponcode: discountCodeInput.value, campTypeId: productMetafields.camp_type_id}).then(
        (result) => {
          discountCodeInput.style.borderColor ="#ff2525";
          if(result.data.valid){
            discountCodeInput.style.borderColor ="#3aeb3f";
          }
          discountCodeValidateButton.innerText = "Validér rabatkode";
        }
      ).catch((error)=> {
        discountCodeValidateButton.innerText = "Validér rabatkode";
      });
    }
    
    function initSelectionForm() {
      resetSelectionForm();
      //insertSelectionStartOptions();
      if (form) {
        form.addEventListener("submit", onSelectionFormSubmit);
      }
      if (discountCodeButton) {
        discountCodeButton.addEventListener("click", function () {
          toggleDiscountCodeInput(true);
        });
        discountCodeValidateButton.addEventListener("click", function () {
          validateCouponCode();
        });
      }
    }
  
    // Login send code form
  
    var SEND_CODE_FORM_SELECTOR = "#campModalSendCodeForm";
    var SEND_CODE_INPUT_SELECTOR = ".camp-modal-send-code-input";
    var SEND_CODE_BUTTON_SELECTOR = ".camp-modal-send-code-button";
    var SEND_CODE_BUTTON_TEXT = "Send kode";
    var SEND_CODE_BUTTON_LOADING_TEXT = "Sender...";
    var SEND_CODE_ERROR_SELECTOR = ".camp-modal-send-code-error";
  
    var sendCodeForm = document.querySelector(SEND_CODE_FORM_SELECTOR);
    var sendCodeInput = document.querySelector(SEND_CODE_INPUT_SELECTOR);
    var sendCodeButton = document.querySelector(SEND_CODE_BUTTON_SELECTOR);
    var sendCodeError = document.querySelector(SEND_CODE_ERROR_SELECTOR);

    var retryPhoneNumber = "";
  
    // TODO: Remove
    function fakePromise() {
      return new Promise(function (resolve) {
        setTimeout(function () {
          resolve();
        }, 1000);
      });
    }
  
    function toggleShowCodeForm(show) {
      if (show) {
        sendCodeForm.style.display = "block";
        setFocusableElements(sendCodeForm);
        sendCodeInput.focus();
      } else {
        sendCodeForm.style.display = "none";
      }
    }
  
    function resetSendCodeForm() {
      retryPhoneNumber = '+45' + sendCodeInput.value;
      sendCodeInput.value = "";
      sendCodeButton.disabled = false;
      sendCodeButton.innerText = SEND_CODE_BUTTON_TEXT;
    }
  
    function toggleSendCodeError(show) {
      if (show) {
        sendCodeError.style.display = "block";
      } else {
        sendCodeError.style.display = "none";
      }
    }
  
    var RECAPTCHA_SITE_KEY = "6Ld5edwsAAAAAJ0SWC5UciWK4_P0aFtuOj_wEfTt";
    var RECAPTCHA_ACTION = "verifySMSShopify";

    function loadRecaptchaScript() {
      return new Promise(function (resolve, reject) {
        if (typeof window.grecaptcha !== "undefined" && window.grecaptcha.ready) {
          window.grecaptcha.ready(resolve);
          return;
        }
        var existing = document.querySelector(
          'script[src*="google.com/recaptcha/api.js"]'
        );
        if (existing) {
          existing.addEventListener("load", function () {
            window.grecaptcha.ready(resolve);
          });
          existing.addEventListener("error", reject);
          return;
        }
        var script = document.createElement("script");
        script.src =
          "https://www.google.com/recaptcha/api.js?render=" + RECAPTCHA_SITE_KEY;
        script.onload = function () {
          window.grecaptcha.ready(resolve);
        };
        script.onerror = reject;
        document.head.appendChild(script);
      });
    }

    function normalizePhoneNumber(rawInput) {
      var digits = String(rawInput || "")
        .replace(/\+\s*4\s*5\s*/, "")
        .replace(/\D/g, "");
      return "+45" + digits;
    }

    function sendValidationCode(resend) {
      var phoneNumber = resend
        ? retryPhoneNumber
        : normalizePhoneNumber(document.getElementById("camp-modal-send-code-input").value);
      retryPhoneNumber = phoneNumber;

      return loadRecaptchaScript()
        .then(function () {
          return window.grecaptcha.execute(RECAPTCHA_SITE_KEY, { action: RECAPTCHA_ACTION });
        })
        .then(function (token) {
          return firebase
            .functions()
            .httpsCallable("startCustomPhoneAuthWeb")({
              phoneNumber: phoneNumber,
              captchaName: RECAPTCHA_ACTION,
              code: token,
            });
        })
        .then(function (data) {
          if (data && data.data && data.data.success) return true;
          throw new Error(
            (data && data.data && data.data.error) || "unable_to_send_sms"
          );
        });
    }
  
    function onSendCodeSubmit(event) {
      event.preventDefault();
  
      if (sendCodeButton.disabled) {
        return;
      }
  
      toggleSendCodeError(false);
      sendCodeButton.disabled = true;
      sendCodeButton.innerText = SEND_CODE_BUTTON_LOADING_TEXT;
  
      sendValidationCode(false)
        .then(function () {
          resetSendCodeForm();
          toggleShowCodeForm(false);
          toggleShowValidateForm(true);
          startValidateResendCount();
        })
        .catch(function (error) {
          Bugsnag.notify(error, function (event) {
            event.addMetadata("campmodal", {
              step: "startCustomPhoneAuthWeb",
              firebaseAuthCode: error && error.code,
              backendError: error && error.message,
            });
          });
          toggleSendCodeError(true);
          var msg = (error && (error.message || error.code)) || "";
          if (error && error.code === "auth/invalid-phone-number") {
            sendCodeError.innerText = "Indtast venligst et gyldigt telefonnummer.";
          } else if (
            /too-many-requests|rate.?limit|rate_limit_exceeded/i.test(msg)
          ) {
            sendCodeError.innerText =
              "Du har forsøgt for mange gange. Prøv venligst igen senere.";
          } else if (/captcha/i.test(msg)) {
            sendCodeError.innerText =
              "Kunne ikke verificere at du er menneskelig. Prøv igen, eller åbn siden i Safari/Chrome hvis du er i en in-app browser.";
          } else {
            sendCodeError.innerText =
              "Der skete en ukendt fejl. Prøv venligst igen.";
          }
          sendCodeButton.disabled = false;
          resetSendCodeForm();
        });
    }
    if (sendCodeForm) {
      sendCodeForm.addEventListener("submit", onSendCodeSubmit);
    }
  
    // Login validate code form
  
    var VALIDATE_CODE_FORM_SELECTOR = "#campModalValidateCodeForm";
    var VALIDATE_CODE_INPUT_SELECTOR = ".camp-modal-validate-code-input";
    var VALIDATE_CODE_BUTTON_SELECTOR = ".camp-modal-validate-code-button";
    var VALIDATE_CODE_BUTTON_TEXT = "Valider kode";
    var VALIDATE_CODE_BUTTON_LOADING_TEXT = "Validerer...";
    var VALIDATE_CODE_ERROR_SELECTOR = ".camp-modal-validate-code-error";
    var VALIDATE_CODE_RESEND_TEXT_SELECTOR =
      ".camp-modal-validate-code-resend-text";
    var VALIDATE_CODE_RESEND_COUNTDOWN_SELECTOR =
      ".camp-modal-validate-code-resend-countdown";
    var VALIDATE_CODE_RESEND_BUTTON_SELECTOR =
      ".camp-modal-validate-code-resend-button";
    var VALIDATE_CODE_RESEND_COUNTDOWN_DURATION = "15"; // seconds
  
    var validateCodeForm = document.querySelector(VALIDATE_CODE_FORM_SELECTOR);
    var validateCodeInput = document.querySelector(VALIDATE_CODE_INPUT_SELECTOR);
    var validateCodeButton = document.querySelector(
      VALIDATE_CODE_BUTTON_SELECTOR
    );
    var validateCodeError = document.querySelector(VALIDATE_CODE_ERROR_SELECTOR);
    var validateCodeResendText = document.querySelector(
      VALIDATE_CODE_RESEND_TEXT_SELECTOR
    );
    var validateCodeResendCountdown = document.querySelector(
      VALIDATE_CODE_RESEND_COUNTDOWN_SELECTOR
    );
    var validateCodeResendButton = document.querySelector(
      VALIDATE_CODE_RESEND_BUTTON_SELECTOR
    );
  
    function toggleShowValidateForm(show) {
      if (show) {
        validateCodeForm.style.display = "block";
        setFocusableElements(validateCodeForm);
        validateCodeInput.focus();
      } else {
        validateCodeForm.style.display = "none";
      }
    }
  
    function resetValidateCodeForm() {
      validateCodeInput.value = "";
      validateCodeButton.disabled = false;
      validateCodeButton.innerText = VALIDATE_CODE_BUTTON_TEXT;
      toggleValidateCodeError(false);
    }
  
    function toggleValidateCodeError(show) {
      if (show) {
        validateCodeError.style.display = "block";
      } else {
        validateCodeError.style.display = "none";
      }
    }
  
    var resendCountInterval;
  
    function startValidateResendCount() {
      validateCodeResendButton.style.display = "none";
      validateCodeResendText.style.display = "inline-block";
      validateCodeResendCountdown.innerText =
        VALIDATE_CODE_RESEND_COUNTDOWN_DURATION;
  
      clearInterval(resendCountInterval);
  
      resendCountInterval = setInterval(function () {
        var seconds = parseInt(validateCodeResendCountdown.innerText, 10);
  
        if (seconds > 1) {
          validateCodeResendCountdown.innerText = seconds - 1;
        } else {
          validateCodeResendText.style.display = "none";
          validateCodeResendButton.style.display = "inline-block";
  
          clearInterval(resendCountInterval);
        }
      }, 1000);
    }
  
    function onValidateCodeSubmit(event) {
      event.preventDefault();

      if (validateCodeButton.disabled) {
        return;
      }

      toggleValidateCodeError(false);
      validateCodeButton.disabled = true;
      validateCodeButton.innerText = VALIDATE_CODE_BUTTON_LOADING_TEXT;

      var code = document.getElementById("camp-modal-validate-code-input").value;

      function showValidateError(error) {
        Bugsnag.notify(error, function (event) {
          event.addMetadata("campmodal", {
            step: "completeCustomPhoneAuth",
            phoneNumber: retryPhoneNumber,
            backendError: error && error.message,
          });
        });
        var msg = (error && (error.message || error.code)) || "";
        if (
          (error && error.code === "auth/invalid-verification-code") ||
          /invalid_code|invalid-verification-code/i.test(msg)
        ) {
          sendCodeError.innerText =
            "Den indtastede kode er ugyldig. Prøv venligst igen.";
        } else {
          sendCodeError.innerText =
            "Der skete en ukendt fejl. Prøv venligst igen.";
        }
        toggleValidateCodeError(true);
        validateCodeButton.disabled = false;
        validateCodeButton.innerText = VALIDATE_CODE_BUTTON_TEXT;
      }

      firebase
        .functions()
        .httpsCallable("completeCustomPhoneAuth")({
          phoneCode: code,
          phoneNumber: retryPhoneNumber,
        })
        .then(function (data) {
          if (data && data.data && data.data.success) {
            return auth
              .signInWithCustomToken(data.data.token)
              .then(function (userCredential) {
                user = userCredential.user;
                redirectToPayment();
              });
          }
          throw new Error((data && data.data && data.data.error) || "invalid_code");
        })
        .catch(showValidateError);
    }
    if (validateCodeForm) {
      validateCodeForm.addEventListener("submit", onValidateCodeSubmit);
    }
    if (validateCodeResendButton) {
      validateCodeResendButton.addEventListener("click", function () {
        startValidateResendCount();
        sendValidationCode(true);
        validateCodeInput.focus();
      });
    }
    
    var firebaseConfig = {
      apiKey: "AIzaSyBw8gmFlVEOGnD2_obkZwpvs69P7a2tQjQ",
      authDomain: "mk-app-prod.firebaseapp.com",
      databaseURL: "https://mk-app-prod.firebaseio.com",
      storageBucket: "mk-app-prod.appspot.com",
      projectId: "mk-app-prod",
    };
    // Initialize Firebase
    firebase.initializeApp(firebaseConfig);
    const functions = firebase.functions();
    const getCampsByType = functions.httpsCallable("getCampsByType");
    const buyCampFun = firebase.functions().httpsCallable("createCampOrder");
    const isCampCouponCodeValid = firebase
      .functions()
      .httpsCallable("isCampCouponCodeValid");
    
    var auth = firebase.auth();
  
    firebase.auth().onAuthStateChanged(function (authuser) {
      if (authuser) {
        isLoggedIn = true;
        user = authuser;
      } else {
      }
    });
  
    let campsReady = false;
    window.addEventListener("load", function () {
  
      document.querySelector(".opencampmodal").addEventListener("click", openModal);
      
      getCampsByType({ camp_type_id: productMetafields.camp_type_id }).then(
        (result) => {
          campoptions = result.data;
          insertSelectionStartOptions();
          campsReady = true;
        }
      );
  
      const queryParams = new URLSearchParams(window.location.search);
  
      success.style.display = "none";
      if (queryParams.has("orderId") && queryParams.get("status") === "success") {
        campOrderNumber = queryParams.get("orderId");
        var orderNumberEl = document.getElementById("campModalSuccessOrderNumber");
        if (orderNumberEl) orderNumberEl.textContent = campOrderNumber;
        openModal();
        formcontainer.style.display = "none";
        success.style.display = "block";
      }
    });
  
  }
  